import React, { useEffect} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import StocksType from './StocksType';
import latestStocks from './StocksMenuList'
import AiAssistantsModal from './AiAssistantsModal';

export default function AiFinancialAnalystCompanySearch({error_msg} :any) {
  const [value, setValue] = React.useState<StocksType | null>(null);
  const [defaultAgent, setDefaultAgent] = React.useState(null);

  useEffect(() => {
    const defaultAgents = JSON.parse(localStorage.getItem('defaultAgents'));

    if (defaultAgents) {
      setDefaultAgent(defaultAgents[0]);
    } else {
      setDefaultAgent("Lima");
    }
  }, []);

  const [data, setData] = React.useState({
    ticker: "",
    company_name: "",
    open: "",
    change_percent: "",
    change: "",
    public_float: "",
    outstanding_shares: "",
    latest_volume: 0
  });

  function validateStocksForm(e) {
    if (value === null) {
      e.preventDefault()
    }
  }

  function handleChange(e) {
    setDefaultAgent(e.target.value);
    localStorage.setItem('defaultAgents', JSON.stringify([e.target.value]));
  }

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Find company to analyze</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">AI Stock Analysis</h4>
              <p className="card-description">Analyze stocks with our AI Analysts/Assistants. <AiAssistantsModal message="Learn How it Works" /></p>
              { error_msg == null ? null : (
                <p className='card-description'>
                  <div className="alert alert-danger" role="alert">{error_msg}</div>
                </p>
              )}
              <form className="forms-sample" action="/financial_analysts_to_chat" method="get">
                  <Autocomplete
                    value={value}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        setValue({
                          name: newValue,
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValue({
                          name: newValue.inputValue,
                        });
                      } else {
                        setValue(newValue);
                      }
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    className="form-group"
                    options={latestStocks}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.name;
                    }}
                    renderOption={(option) => option.name}
                    //style={{ width: 300 }}
                    fullWidth
                    freeSolo
                    renderInput={(params) => (
                      <TextField {...params} label="Find a company" color="primary" variant="outlined" name="stock" />
                    )}
                  />
                  <div className="col-md-6">
                    <p className="card-description">Assistant:</p>
                    <div className="form-group">
                      <div className="form-check">
                        <label className="form-check-label">
                          <input type="radio" className="form-check-input" name="agent" id="limaOptionsRadios" value="Lima" onChange={handleChange} checked={ defaultAgent === 'Lima' } />
                            Lima
                        </label>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <input type="radio" className="form-check-input" name="agent" id="summerOptionsRadios" value="Summer" onChange={handleChange} checked={ defaultAgent === 'Summer' } />
                            Summer
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <button type="submit" onClick={ (e) => validateStocksForm(e) } className="btn btn-gradient-primary">Search</button>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
